if (typeof window.viendoScriptLoaded === 'undefined') {

    window.viendoScriptLoaded = true;

    const texto = document.querySelector(".x_viendo");
    let max = 100;
    let min = 50;
    let numeroRandom = Math.floor(Math.random() * (max - min) + min);

    function Viendo() {
        if (texto) {
            texto.innerHTML = numeroRandom;
            if (numeroRandom >= min && numeroRandom < max) {
                let maxSumar = 4;
                let minSumar = 1;
                numeroRandom += Math.floor(Math.random() * (maxSumar - minSumar) + minSumar);
            } else if (numeroRandom >= max) {
                let maxRestar = 5;
                let minRestar = 1;
                numeroRandom -= Math.floor(Math.random() * (maxRestar - minRestar) + minRestar);
            }
        }
    }

    (function actualizarViendo() {
        Viendo();
        setTimeout(actualizarViendo, 40000);
    })();

}